import { render, staticRenderFns } from "./BinderIcon.vue?vue&type=template&id=74e20ffc&scoped=true&"
import script from "./BinderIcon.vue?vue&type=script&lang=js&"
export * from "./BinderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e20ffc",
  null
  
)

export default component.exports